export default "__VITE_ASSET__Dg31e5Nj__"